module.exports = __webpack_public_path__ + "img/cardImg.b51dc630.svg";